import {Inject, Injectable} from '@angular/core'
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import {HelperService} from "@akiru/bankid"
import {LOCAL_STORAGE} from "./local-storage.provider"
import {ACCESS_TOKEN_NAME} from './types'

/**
 * Inject to set auth header on all requests.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * @param injectedLocalStorage
   */
  constructor(@Inject(LOCAL_STORAGE) private injectedLocalStorage: Storage
  ) {
  }

  /**
   * Intercept all requests and add auth token. We should however
   * do this only on white listed requests so that we do not
   * send our tokens when not needed.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    /**
     * Only send authorization bearer if endpoint is relevant
     */
    if (req.url.indexOf('verify') !== -1 || req.url.indexOf('api') !== -1) {
      const token = HelperService.ValidateToken(this.injectedLocalStorage.getItem(ACCESS_TOKEN_NAME))
      const headers = req.headers
      const authReq = req.clone({
        headers: headers.set('Authorization', `Bearer ${token}`)
      })
      return next.handle(authReq)
    }

    /**
     * Else set no more headers
     */
    return next.handle(req)
  }
}
